import React from "react"

export type BarraInformacoesOrcamentoProps = {

}

export const BarraInformacoesOrcamento = (props: BarraInformacoesOrcamentoProps) => {

    const aba = <div>
    </div>

    const nomeClienteOrcamento = <div>
    </div>

    const maisInformacoes = <div>
        
    </div>

    return <>
        <div>
            {aba}

            {nomeClienteOrcamento}

            {maisInformacoes}
        </div>
    </>
}